import { Link } from 'react-router-dom';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';
import { mobileMediaCondition } from 'utils/helpers/device-utils';

export const NavBarWrapper = styled.div`
    position: sticky;
    top: 0;
    z-index: 1;

    width: 100%;
    height: 48px;

    color: #ebeaf1;

    background-color: var(--backgroundColor);
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.25);

    .hockeyTech & {
        background-color: var(--blackColor);
    }

    @media ${mobileMediaCondition} {
        height: 62px;
        padding: 4px 0;
    }
`;

export const Brand = styled.div`
    cursor: pointer;
`;

export const NavBarMenu = styled.div`
    color: ${({ isActive }) => (isActive ? 'var(--uiPrimaryColor)' : 'var(--defaultColor)')};

    cursor: pointer;
`;

export const TabBlock = styled.div`
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 30px 30px;
`;

export const TabButton = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-width: 18%;
    max-width: 49%;
    height: 40px;

    border: 4px solid var(--uiPrimaryColor);
    border-radius: 10px;

    color: ${({ isActive }) => (isActive ? 'var(--secondOption)' : 'var(--uiPrimaryColor)')};
    font-weight: bold;

    font-size: 16px;
    text-transform: uppercase;

    background-color: ${({ isActive }) => (isActive ? 'var(--uiPrimaryColor)' : 'var(--secondOption)')};
    cursor: pointer;

    &:hover,
    &:focus {
        color: ${({ isActive }) => (isActive ? 'var(--secondOption)' : 'var(--uiPrimaryColor)')};
        text-decoration: none;
    }

    @media ${mobileMediaCondition} {
        font-size: 11px;
    }
`;
